import React from "react";
import {getFormattedPrice} from "../../../../assets/js/get-formatted-price";

class OrderSummaryGrandTotal extends React.Component {
    constructor(props) {
        super(props);
        this.grandTotalRef = React.createRef();

        this.state = {
            grandTotalRefFixed: true
        };
    }

    checkElementBottom(el) {
        return (el.getBoundingClientRect().bottom + 16) <= window.innerHeight;
    }

    componentDidMount() {
        document.addEventListener('scroll', this.trackScrolling);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.trackScrolling);
    }

    trackScrolling = () => {
        const grandTotal = this.grandTotalRef.current;
        if (this.checkElementBottom(grandTotal)) {
            this.setState({grandTotalFixed: false})
        } else {
            this.setState({grandTotalFixed: true})
        }
    };

    render() {
        const {grandTotalFixed} = this.state;
        const {label, grandTotalNumber} = this.props;

        return (
            <div className="order-summary__grand-total" ref={this.grandTotalRef}>
                <div className={`order-summary__row ${grandTotalFixed ? 'fixed' : ''}`}>
                    <div className="order-summary__row-inner">
                        <span className="order-summary__label">{label}</span>
                        <span className="order-summary__price">€ {getFormattedPrice(grandTotalNumber)}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export {OrderSummaryGrandTotal}